import { useRef, useState } from 'react';
import { Sheet, SheetRef } from 'react-modal-sheet';
import { HStack } from 'ui_2';
import { Stats } from './Stats';
import { Diary } from './Diary';

export const SquashDetails = () => {
  const [activeTab, setActiveTab] = useState<'stats' | 'diary'>('stats');
  const [snapIndex, setSnapIndex] = useState<0 | 1>(1);
  const sheetRef = useRef<SheetRef>();

  const snapTo = (i: 0 | 1) => {
    setSnapIndex(i);
    sheetRef.current?.snapTo(i);
  };

  return (
    <div className='absolute bottom-0 left-1/2 z-40 w-full max-w-[478px] -translate-x-1/2'>
      <Sheet
        isOpen={true}
        onClose={() => snapTo(1)}
        snapPoints={[0.55, 60]}
        initialSnap={snapIndex}
        disableDrag={true}
        style={{
          background: 'transparent',
          zIndex: 30,
          maxWidth: '478px',
          margin: '0 auto',
        }}
      >
        <Sheet.Container
          className='[&_.react-modal-sheet-content]:rounded-t-xl [&_.react-modal-sheet-content]:border-0 [&_.react-modal-sheet-content]:bg-squashBg'
          style={{
            background: 'transparent',
          }}
          onTap={(e) => {
            if (snapIndex > 0) {
              snapTo(0);
              e.stopPropagation();
              e.stopImmediatePropagation();
            }
          }}
        >
          <Sheet.Content className='!overflow-visible !rounded-t-xl'>
            <div
              className={`z-[100] flex h-[52px] w-full ${
                snapIndex === 0 ? '' : 'cursor-pointer'
              } box-shadow-none relative mx-auto items-center justify-center rounded-t-xl bg-squashBg`}
              onClick={() => {
                if (snapIndex === 1) snapTo(0);
              }}
            >
              <div className='relative flex h-[20px] w-full flex-col gap-2'>
                <HStack className='h-10 w-full items-center'>
                  <div
                    className='w-1/2 cursor-pointer text-center text-[12px]'
                    onClick={() => setActiveTab('stats')}
                  >
                    Stats
                  </div>
                  <div
                    className='w-1/2 cursor-pointer text-center text-[12px]'
                    onClick={() => setActiveTab('diary')}
                  >
                    Diary
                  </div>
                </HStack>
                <HStack className='h-[6px] w-full flex-shrink-0'>
                  <div
                    className={`h-full w-1/2 transition-colors ${
                      activeTab === 'stats' ? 'bg-black' : 'bg-squashGray-200'
                    }`}
                  />
                  <div
                    className={`h-full w-1/2 transition-colors ${
                      activeTab === 'diary' ? 'bg-black' : 'bg-squashGray-200'
                    }`}
                  />
                </HStack>
              </div>
            </div>
            <div className='flex-1 overflow-auto bg-squashBg p-4'>
              {activeTab === 'stats' && <Stats />}
              {activeTab === 'diary' && <Diary />}
            </div>
          </Sheet.Content>
        </Sheet.Container>
        {snapIndex === 0 ? <Sheet.Backdrop onTap={() => snapTo(1)} /> : <></>}
      </Sheet>
    </div>
  );
};
